/**
 * The IClock interface defines the functions a clock should implement for use with IStoryFrameworkPlayer. The IStoryFrameworkPlayer
 * handles time as an integer value, the clock interface is used to abstract this time handling. The reason
 * there is an abstract clock is that there can be different scenario's of time handling in games that use the IStoryFrameworkPlayer. E.g.:
 * 
 * <ul>
 * <li>Using real time: use a real clock in which events still trigger while the player is not in the game.</li>
 * <li>Using game time: only count time that the use is in game so the player can exit the game and start
 * from the time he left the game.</li>
 * </ul>
 * 
 * <p>Although the time unit you use is flexible it is highly recommended to keep the default, using milliseconds
 * as the value.</p> 
 * @constructor
 **/
export default class IClock {
    constructor() {
    }
    /**
     * Get the current time on the clock
     * @returns {number} The current time as an int
     */
    getCurrentTime() {
    }
}


